import React, { Component } from "react";
import { connect } from "react-redux";
import {
  req_list_lrs_buildingSpace,
  req_list_lrs_spaceInformation,
  req_list_lrs_lend_public,
  req_downloadfile_lrs_lend,
} from "../../api";
import {
  Table,
  Select,
  Card,
  Button,
  Tag,
  Tooltip,
  DatePicker,
  Modal,
} from "antd";
import { API_BASE } from "../../utils/contrains";
import CorrectLogAddModal from "./correct-log-add-modal";

const { Option } = Select;
class SpaceStatusSearch extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    items: [],
    item: {},
    userLevel: "NORMAL",
    selectedBuilding: "NONE",
    selectedRoom: "NONE",
    selectedDateTag: "NONE",
    selectedRoomInfo: null,
    domnloadFile: "",
    buildings: [],
    rooms: [],
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    this.api_list_buildings();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    this.setState({ loading: true, items: [] });
    const { selectedBuilding, selectedRoom, selectedDateTag } = this.state;
    const DateTag = selectedDateTag === "" ? "NONE" : selectedDateTag;
    //console.log( selectedBuilding, selectedRoom, selectedDateTag)
    const result = await req_list_lrs_lend_public(
      selectedBuilding,
      selectedRoom,
      DateTag
    );
    this.setState({ loading: false });
    //console.log(result);
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
      //console.log(this.state);
    } else {
      const items = [];
      this.setState({ items });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, selectedBuilding, selectedRoom, selectedDateTag } =
      this.state;
    const DateTag = selectedDateTag === "" ? "NONE" : selectedDateTag;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_lrs_lend(
      userCode,
      userLevel,
      selectedBuilding,
      selectedRoom,
      DateTag,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "空間借用紀錄";
    a.click();
  };

  api_list_buildings = async () => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_list_lrs_buildingSpace(token);
    this.setState({ loading: false });

    const buildings = result.data;
    this.setState({ buildings });
    //console.log(buildings);
  };

  api_list_rooms = async (buildingCode) => {
    const result = await req_list_lrs_spaceInformation(buildingCode);
    const rooms = result.total > 0 ? result.data : [];
    this.setState({ rooms });
    // console.log(rooms);
  };

  // 數據配置設定 //////////////////////////////////////////////

  setRooms = (value) => {
    this.api_list_rooms(value);
  };

  init_columns = () => {
    this.columns = [
      {
        title: "日期",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { DateTag, WeekCode } = item;
          return (
            <>
              <span>
                {DateTag}({WeekCode})
              </span>
            </>
          );
        },
      },
      {
        title: "時間",
        width: 30,
        render: (item) => {
          const { TimeStart, TimeEnd } = item;
          return (
            <>
              <span
                style={{
                  color:
                    TimeStart === "2200" || TimeStart === "2400" ? "red" : "",
                }}
              >
                {TimeStart}-{TimeEnd}
              </span>
            </>
          );
        },
      },
      {
        title: "地點",
        width: 45,
        render: (item) => {
          const { RoomCode, RoomName } = item;
          return (
            <span>
              {RoomCode}-{RoomName}
            </span>
          );
        },
      },
      {
        title: "使用人證號",
        dataIndex: "BorrowerId",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "使用人",
        width: 40,
        render: (item) => {
          const {
            // ApplyStatus,
            // ReviewStatus,
            NeedSignInOut,
            //SignInTime,
            SignOutTime,
            BorrowerName,
            BorrowerPhone,
            HasCorrect,
          } = item;
          const phone = "tel:" + BorrowerPhone;
          // const IsAgree =
          //   ApplyStatus.substring(0, 5) === "AGREE" ? true : false;
          return (
            <div>
              <Tooltip placement="top" title={BorrowerPhone}>
                <a
                  href={phone}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-primary btn-sm"
                >
                  <i className="fas fa-phone-volume"></i>
                </a>
              </Tooltip>{" "}
              {HasCorrect === "NO" ? (
                <button
                  className="btn btn-outline-warning btn-sm"
                  onClick={() => this.handle_show_ui_modal("view", item)}
                  disabled={HasCorrect === "YES" ? true : false}
                >
                  <Tooltip placement="top" title={"請輸入違規內容"}>
                    <i className="fas fa-flag"></i>
                  </Tooltip>
                </button>
              ) : (
                <>
                  <Tooltip placement="top" title={"已註記違規"}>
                    <button className="btn btn-outline-danger btn-sm">
                      <i className="fas fa-flag"></i>
                    </button>
                  </Tooltip>
                </>
              )}
              <span>{BorrowerName}</span>
              {
                //ReviewStatus === "END" && IsAgree && NeedSignInOut === "YES"
                NeedSignInOut === "YES" ? (
                  <>
                    {SignOutTime.substring(0, 10) !== "1999-01-01" ? (
                      <Button disabled={true}>已離退</Button>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  ""
                )
              }
            </div>
          );
        },
      },
      {
        title: "狀態",
        width: 40,
        responsive: ["md"],
        render: (item) => {
          const { ApplyStatus, MustConfirmLevel, ReviewStatus } = item;
          return (
            <>
              {ReviewStatus === "REVIEW" ? (
                <>
                  <Tag
                    color={this.style_switch_color("APPLY_STATUS", ApplyStatus)}
                  >
                    {this.style_switch_text("APPLY_STATUS", ApplyStatus)}
                  </Tag>
                  <Tag
                    color={this.style_switch_color(
                      "CONFIRM_LEVEL",
                      MustConfirmLevel
                    )}
                  >
                    {this.style_switch_text("CONFIRM_LEVEL", MustConfirmLevel)}
                  </Tag>
                </>
              ) : (
                <>
                  <Tag
                    color={this.style_switch_color(
                      "RESULT_STATUS",
                      ApplyStatus
                    )}
                  >
                    {this.style_switch_text("RESULT_STATUS", ApplyStatus)}
                  </Tag>
                </>
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color(type, param) {
    switch (type) {
      case "CONFIRM_LEVEL":
        switch (param) {
          case "A":
            return "PowderBlue";
          case "B":
            return "LightSkyBlue";
          case "C":
            return "DarkBlue";
          default:
            return "Black";
        }
      case "APPLY_STATUS":
        switch (param) {
          case "APPLY":
            return "DarkSlateBlue";
          case "AGREEA":
            return "PaleGreen";
          case "AGREEB":
            return "OliveDrab";
          case "AGREEC":
            return "DarkGreen";
          case "REFUSEA":
            return "DarkGray";
          case "REFUSEB":
            return "DimGray";
          case "REFUSEC":
            return "Black";
          case "CANCEL":
            return "SlateGray";
          default:
            return "Black";
        }
      case "RESULT_STATUS":
        switch (param) {
          case "APPLY":
            return "DarkSlateBlue";
          case "AGREEA":
          case "AGREEB":
          case "AGREEC":
            return "Green";
          case "REFUSEA":
          case "REFUSEB":
          case "REFUSEC":
            return "Black";
          case "CANCEL":
            return "SlateGray";
          default:
            return "Black";
        }
      default:
        return "Black";
    }
  }

  style_switch_text(type, param) {
    switch (type) {
      case "CONFIRM_LEVEL":
        switch (param) {
          case "A":
            return "只要一審";
          case "B":
            return "須到二審";
          case "C":
            return "須到三審";
          default:
            return "未定義";
        }
      case "APPLY_STATUS":
        switch (param) {
          case "APPLY":
            return "申請中";
          case "AGREEA":
            return "一審已同意";
          case "AGREEB":
            return "二審已同意";
          case "AGREEC":
            return "三審已同意";
          case "REFUSEA":
            return "一審不同意";
          case "REFUSEB":
            return "二審不同意";
          case "REFUSEC":
            return "三審不同意";
          case "CANCEL":
            return "已註銷";
          default:
            return "未定義";
        }
      case "RESULT_STATUS":
        switch (param) {
          case "APPLY":
            return "待審";
          case "AGREEA":
          case "AGREEB":
          case "AGREEC":
            return "同意";
          case "REFUSEA":
          case "REFUSEB":
          case "REFUSEC":
            return "不同意";
          case "CANCEL":
            return "已註銷";
          default:
            return "Black";
        }
      default:
        return "Black";
    }
  }

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handleBuildingChange = (value) => {
    this.setState({
      items: [],
      selectedBuilding: value,
      selectedRoom: "NONE",
      selectedRoomInfo: null,
    });
    this.setRooms(value);
    //console.log(value);
  };

  handleRoomChange = (value) => {
    const { rooms } = this.state;
    const selectedRoomInfo = rooms.filter(function (item) {
      return item.RoomCode === value;
    })[0];
    this.setState({
      items: [],
      selectedRoom: value,
      selectedRoomInfo: selectedRoomInfo,
    });
    //console.log("selectedRoomInfo", selectedRoomInfo);
  };

  handleDateChange = (date, dateString) => {
    this.setState({
      items: [],
      selectedDateTag: dateString,
    });
    console.log(dateString);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        // this.api_add_view_log(item)
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true, item });
        break;
      case "delete":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定刪除此筆數據`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "download":
        break;
      default:
    }
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      selectedBuilding,
      selectedRoom,
      buildings,
      rooms,
      items,
      item,
      isShowModal,
    } = this.state;
    const listRooms =
      rooms.length > 0 ? (
        <>
          {rooms.map((item) => (
            <Option
              key={item.RoomCode}
              value={item.RoomCode}
              disabled={item.RoomStatus === "CLOSE"}
            >
              {item.RoomCode} {item.RoomTwName}
            </Option>
          ))}
        </>
      ) : (
        ""
      );
    const title = (
      <div className="row">
        <div className="col-md">
          <Select
            style={{ width: 180 }}
            onChange={this.handleBuildingChange}
            defaultValue={selectedBuilding}
          >
            <Option key={"NONE"} value={"NONE"}>
              請選擇
            </Option>
            {buildings.map((building) => (
              <Option key={building.BuildingCode} value={building.BuildingCode}>
                {building.BuildingCode}-{building.BuildingName}
              </Option>
            ))}
          </Select>
          <Select
            style={{ width: 220 }}
            onChange={this.handleRoomChange}
            defaultValue={selectedRoom}
            allowClear
          >
            <Option value={"NONE"}>請選擇</Option>
            {listRooms}
          </Select>
          <DatePicker onChange={this.handleDateChange} />
          <Button type="primary" onClick={this.handle_data_refresh}>
            <i className="fas fa-search"></i>{" "}
            <span style={{ marginLeft: "4px" }}> 查詢</span>
          </Button>{" "}
          <Tooltip placement="top" title="重新整理">
            <Button type="primary" onClick={this.handle_data_refresh}>
              <i className="fas fa-sync-alt"></i>
            </Button>
          </Tooltip>{" "}
          <Button type="primary" onClick={this.handle_data_download}>
            <i className="fas fa-cloud-download-alt element-hidden"></i>
            <span style={{ marginLeft: "4px" }}> 下載</span>
          </Button>
          <p></p>
        </div>
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          columns={this.columns}
          // onChange={this.handle_data_refresh}
          dataSource={items}
          pagination={false}
        />

        <Modal
          destroyOnClose={true}
          visible={isShowModal}
          width={800}
          onOk={() => {
            this.setState({ isShowModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <CorrectLogAddModal log={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceStatusSearch);
